const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AGENT_API_BASE_URL = process.env.REACT_APP_AGENT_BASE_URL;
console.log(`AGENT_API_BASE_URL`, AGENT_API_BASE_URL)
export const endpoints = {
  getReceptionAgentResponse: `${API_BASE_URL}/v1/getReceptionAgentResponse`,
  getTutorResponse: `${API_BASE_URL}/tutor-response`,
};

export const agentEndpoints = {
  getResponse: `${AGENT_API_BASE_URL}/v1/adminChat`,
  getUserChats: `${AGENT_API_BASE_URL}/v1/getUserChats`,
  getChatHistory: `${AGENT_API_BASE_URL}/v1/getChatHistory`,
  clearChatSession: `${AGENT_API_BASE_URL}/v1/clearChatSession`,
  createNewSession: `${AGENT_API_BASE_URL}/v1/createNewSession`,
  getMessageById: `${AGENT_API_BASE_URL}/v1/getMessageById`,
  getBulkReportItemById: `${AGENT_API_BASE_URL}/v1/getBulkReportItemById`,
  createStudentPerformanceBulkReport: `${AGENT_API_BASE_URL}/v1/createStudentPerformanceBulkReport`,
  getAllReports: `${AGENT_API_BASE_URL}/v1/getAllBulkReports`,
  deleteBulkReport: `${AGENT_API_BASE_URL}/v1/deleteBulkReport`,
  getBulkReportErrorItems: `${AGENT_API_BASE_URL}/v1/getBulkReportItemErrorDetails`,
  exportChatMessage: `${AGENT_API_BASE_URL}/v1/exportChatMessage`,
  getAttendance: `${AGENT_API_BASE_URL}/v1/getAttendance`,
  generateStudentReport: `${AGENT_API_BASE_URL}/v1/generateSingleStudentPerformanceReport`,
  downloadPDFReport: `${AGENT_API_BASE_URL}/v1/downloadPDFReport`,
  getReports: (schoolId) => `${AGENT_API_BASE_URL}/v1/reports?schoolId=${schoolId}`,
  getReportItems: (reportId, schoolId) => `${AGENT_API_BASE_URL}/v1/reports/${reportId}/items?schoolId=${schoolId}`,
  login: `${AGENT_API_BASE_URL}/v1/login`,
  getLessonPlanReport: `${AGENT_API_BASE_URL}/v1/lesson-plans/report`,
}